// import HTTP from '@/utils/http'

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {},
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/view/pages/About/store/index.js